import React from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { useLanguage } from '../contexts/LanguageContext';

const SECTIONS = [
  'acceptance',
  'services',
  'eligibility',
  'userObligations',
  'intellectualProperty',
  'privacy',
  'limitation',
  'termination',
  'governing',
  'changes',
];

export const TermsAndConditions = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-50 glass border-b border-border">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('termsAndConditions.backToHome')}
          </Button>
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_567a6262-0291-4069-9a05-5048d6f99ff3/artifacts/3eapd20t_logo.png"
              alt="Shenbury"
              className="h-8 w-8"
            />
            <span className="text-xl font-serif font-semibold text-gradient-primary">Shenbury</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Title Section */}
          <div className="text-center mb-12">
            <Badge variant="outline" className="glass border-secondary/30 mb-4">
              <FileText className="w-4 h-4 mr-2 inline" />
              {t('termsAndConditions.subtitle')}
            </Badge>
            <h1 className="text-4xl sm:text-5xl font-serif font-bold mb-4">
              {t('termsAndConditions.title')}
            </h1>
            <div className="flex items-center justify-center gap-6 text-sm text-muted-foreground">
              <span>{t('termsAndConditions.effectiveDate')}: January 22, 2026</span>
              <span>•</span>
              <span>Sheboli Digital Technology Company Ltd.</span>
            </div>
          </div>

          {/* Sections */}
          {SECTIONS.map((section) => (
            <Card key={section} className="glass border-card-border mb-8">
              <CardHeader>
                <CardTitle className="text-2xl font-serif text-foreground">
                  {t(`termsAndConditions.sections.${section}.title`)}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-muted-foreground leading-relaxed">
                <p>
                  {t(`termsAndConditions.sections.${section}.content`)}
                </p>
              </CardContent>
            </Card>
          ))}

          {/* Footer */}
          <div className="text-center py-8 border-t border-border">
            <p className="text-sm text-muted-foreground mb-4">
              © 2026 Sheboli Digital Technology Company Ltd. — These terms of service form a legally binding agreement.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
